import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-companies',
  templateUrl: './admin-companies.component.html',
  styleUrls: ['./admin-companies.component.css']
})
export class AdminCompaniesComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  feedbackID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  companies = [];
  users = [];
  form: FormGroup;
  messageErr;
  pub = 0
  priv = 0;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {
     }

     ngOnInit(): void {
      this.fetchBusinesses();

    }

    fetchBusinesses() {

      this.http.get(environment.ADMIN_FETCH_BUSINESSES, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.companies = res.message;

            for (let i = 0; i < this.companies.length; i++) {
              const element = this.companies[i];
              if(element.public_leaver){
                this.pub += 1;
              }
              else{
                this.priv += 1;
              }
            }
  
          }
          else {
            console.log('ei ole kyseistä käyttäjää')
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
  
  
    }


}
